import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { forToFix } from "../../CommonMethhods/CovertRupees";
import LoaderForSearch from "../Common/LoaderForSearch";

function RevenueTable(props) {
  let gridVal = props?.gridVal;
  const brokingDrop = props?.brokingDrop;
  const handleScroll = props?.handleScroll;
  const scrollLoader = props?.scrollLoader;
  const totalValue = props.totalValue;
  const subBrokingType = props.subBrokingType;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {gridVal && gridVal ? (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col" className="text-center">
                  Franchisee Code
                </th>
                <th scope="col" className="text-center">
                  Sub Broker Code
                </th>

                <th scope="col" className="text-center">
                  {Constants.client_Name}
                </th>
                <th scope="col">{Constants.Client_Code}</th>
                {brokingDrop === "Broking Product" ? (
                  ""
                ) : (
                  <>
                    <th scope="col" className="text-center">
                      Equity
                    </th>
                    <th scope="col" className="text-center">
                      Future/Option
                    </th>

                    <th scope="col" className="text-center">
                      MTF
                    </th>
                  </>
                )}

                <th scope="col" className="text-center">
                  Revenue Amount
                </th>
                <th scope="col" className="text-center">
                  Volume
                </th>
              </tr>
            </thead>
            <tbody id="clientrevenue-scroll" onScroll={handleScroll}>
              {gridVal &&
                gridVal.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item?.rmCode || "-"}</td>
                      <td>{item?.subBrokerCode || "-"}</td>
                      <td>{item?.clientName || "-"}</td>
                      <td>{item?.clientCode || "-"}</td>
                      {brokingDrop === "Broking Product" ? (
                        ""
                      ) : (
                        <>
                          <td>{item?.equity || 0}</td>
                          <td>{item?.fno || 0}</td>

                          <td>{item?.mtf || 0}</td>
                        </>
                      )}

                      <td>{item?.revenueAmt || 0}</td>
                      <td>{item?.volume || 0}</td>
                    </tr>
                  );
                })}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
            {brokingDrop === "All" && (
              <tbody className="totalRevnueData">
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {totalValue?.totalEquity
                      ? forToFix(totalValue?.totalEquity)
                      : 0}
                  </td>
                  <td>
                    {totalValue?.totalFno ? forToFix(totalValue?.totalFno) : 0}
                  </td>
                  <td>
                    {totalValue?.totalMtf ? forToFix(totalValue?.totalMtf) : 0}
                  </td>
                  <td>
                    {totalValue?.totalRevenueAmt
                      ? forToFix(totalValue?.totalRevenueAmt)
                      : 0}
                  </td>
                  <td>
                    {totalValue?.totalVolume
                      ? forToFix(totalValue?.totalVolume)
                      : 0}
                  </td>
                </tr>
              </tbody>
            )}
            {brokingDrop === "Broking Product" && (
              <tbody className="totalRevnueData">
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {subBrokingType === "EQUITY" ? (
                    <td>
                      {totalValue?.totalEquity
                        ? forToFix(totalValue?.totalEquity)
                        : 0}
                    </td>
                  ) : subBrokingType === "FNO" ? (
                    <td>
                      {totalValue?.totalFno
                        ? forToFix(totalValue?.totalFno)
                        : 0}
                    </td>
                  ) : (
                    <td>
                      {totalValue?.totalMtf
                        ? forToFix(totalValue?.totalMtf)
                        : 0}
                    </td>
                  )}

                  <td>
                    {totalValue?.totalVolume
                      ? forToFix(totalValue?.totalVolume)
                      : 0}
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default RevenueTable;
